import noSSR from '../../utils/no-ssr'

const DashboardWithoutSSR = noSSR(() => import('../../app/dashboard/home'))

export default DashboardWithoutSSR
